import { ReactNode } from "react";

const normalize = (value: string) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const highlightSearchText = (text?: string, query?: string): ReactNode => {
  if (!text || !query) return text;

  const normText = normalize(text);
  const normQuery = normalize(query);
  if (!normQuery) return text;

  const parts: Array<string | JSX.Element> = [];
  let start = 0;
  let idx = normText.indexOf(normQuery, start);

  while (idx !== -1) {
    if (idx > start) parts.push(text.slice(start, idx));
    const end = idx + normQuery.length;
    parts.push(
      <mark
        key={`${idx}-${end}`}
        className="rounded bg-amber-100 px-0.5 text-inherit dark:bg-amber-900/50"
      >
        {text.slice(idx, end)}
      </mark>
    );
    start = end;
    idx = normText.indexOf(normQuery, start);
  }

  if (start < text.length) parts.push(text.slice(start));
  return <>{parts}</>;
};

export { normalize as normalizeSearchText };
